module.exports = __webpack_public_path__ + "img/setting.495910fb.svg";